import React from "react";
import styles from "./Label.module.css";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

const Label = (props) => {
  const { title, content } = props;
  return (
    <div className={styles.container}>
      <Typography variant="subtitle2" gutterBottom className={styles.text_item}>
        {title}
      </Typography>

      <Typography
        variant="body1"
        gutterBottom
        className={`${styles.text_item} ${styles.text_content}`}
      >
        {content}
      </Typography>
    </div>
  );
};

Label.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

export default Label;
